var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../../nunjucks.config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["front/utils/macros.jinja"] = require( "front/utils/macros.jinja" );




var shim = require("/var/www/django/gbn.moscow/application/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["assets/app/front/components/IndexPartners/IndexPartners.jinja"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = 0;
var colno = 0;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("front/utils/macros.jinja", false, "assets/app/front/components/IndexPartners/IndexPartners.jinja", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
context.setVariable("macros", t_1);
output += "\n\n<div class=\"IndexPartners\">\n    <div class=\"IndexPartners-experience\">\n        <div class=\"IndexPartners-experienceCount\">";
output += runtime.suppressValue((lineno = 4, colno = 75, runtime.callWrap(runtime.memberLookup((t_1),"svgSprite"), "macros[\"svgSprite\"]", context, ["five",runtime.makeKeywordArgs({"caller": (function (){var macro_t_4 = runtime.makeMacro(
[], 
[], 
function (kwargs) {
var callerFrame = frame;
frame = frame.push(true);
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
var t_5 = "";;
frame = frame.pop();
return new runtime.SafeString(t_5);
});
return macro_t_4;})()})])), env.opts.autoescape);
output += "</div>\n        <div class=\"IndexPartners-experienceText\">Минимальный опыт эксперта бюро — 5 лет</div>\n    </div>\n    <div class=\"IndexPartners-blocks\">\n        <div class=\"IndexPartners-block\">\n            <div class=\"IndexPartners-blockText\">\n                <div class=\"IndexPartners-header\">Преимущества для клиентов бюро от банков</div>\n                <div class=\"IndexPartners-desc\">Банки-партнёры бюро помогают нашим клиентам быстрее получить ипотечный\n                    кредит, а иногда дают пониженную ставку, так как доверяют нам.\n                </div>\n            </div>\n            <div class=\"IndexPartners-blockPartners\">\n                <a class=\"IndexPartners-partner IndexPartners-partner--vtb\" href=\"https://www.vtb.ru/personal/ipoteka/\"\n                   target=\"_blank\">\n                    ";
output += runtime.suppressValue((lineno = 18, colno = 44, runtime.callWrap(runtime.memberLookup((t_1),"svgSprite"), "macros[\"svgSprite\"]", context, ["vtb",runtime.makeKeywordArgs({"caller": (function (){var macro_t_6 = runtime.makeMacro(
[], 
[], 
function (kwargs) {
var callerFrame = frame;
frame = frame.push(true);
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
var t_7 = "";;
frame = frame.pop();
return new runtime.SafeString(t_7);
});
return macro_t_6;})()})])), env.opts.autoescape);
output += "</a>\n                <a class=\"IndexPartners-partner IndexPartners-partner--sber\"\n                   href=\"https://www.sberbank.ru/ru/person/credits/homenew\" target=\"_blank\">\n                    ";
output += runtime.suppressValue((lineno = 21, colno = 44, runtime.callWrap(runtime.memberLookup((t_1),"svgSprite"), "macros[\"svgSprite\"]", context, ["sber",runtime.makeKeywordArgs({"caller": (function (){var macro_t_8 = runtime.makeMacro(
[], 
[], 
function (kwargs) {
var callerFrame = frame;
frame = frame.push(true);
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
var t_9 = "";;
frame = frame.pop();
return new runtime.SafeString(t_9);
});
return macro_t_8;})()})])), env.opts.autoescape);
output += "</a>\n            </div>\n        </div>\n        <div class=\"IndexPartners-block\">\n            <div class=\"IndexPartners-blockText\">\n                <div class=\"IndexPartners-header\">Скидки клиентам бюро от&nbsp;студий&nbsp;интерьера</div>\n                <div class=\"IndexPartners-desc\">Наши партнёры, студии интерьера, дают скидки от 10% до 20% на свои\n                    услуги.\n                    Размер скидки зависит от площади объекта.\n                </div>\n            </div>\n            <div class=\"IndexPartners-blockPartners\">\n                <a class=\"IndexPartners-partner IndexPartners-partner--km\" href=\"http://km-studio.info/\"\n                   target=\"_blank\">\n                    <svg viewBox=\"0 0 25 19\" width=\"25\" height=\"19\" xmlns=\"http://www.w3.org/2000/svg\">\n                        <defs>\n                            <linearGradient x1=\"100%\" y1=\"0%\" x2=\"38.828%\" y2=\"32.406%\" id=\"a\">\n                                <stop stop-color=\"#FFF\" stop-opacity=\".9\" offset=\"0%\"/>\n                                <stop stop-color=\"#FFF\" stop-opacity=\"0\" offset=\"100%\"/>\n                            </linearGradient>\n                            <linearGradient x1=\"-8.38%\" y1=\"39.781%\" x2=\"75.62%\" y2=\"67.018%\" id=\"b\">\n                                <stop stop-color=\"#FFF\" offset=\"0%\"/>\n                                <stop stop-color=\"#FFF\" stop-opacity=\".739\" offset=\"45.475%\"/>\n                                <stop stop-color=\"#FFF\" stop-opacity=\"0\" offset=\"100%\"/>\n                            </linearGradient>\n                        </defs>\n                        <g fill-rule=\"evenodd\">\n                            <path d=\"M0 0h23.394v15.108H0z\"/>\n                            <path fill=\"url(#a)\" d=\"M23.394 0v15.108l-7.735-7.48z\"/>\n                            <path fill=\"#FFF\" d=\"M15.61 0h7.784l-7.74 7.61L11.62 3.7z\"/>\n                            <path fill=\"url(#b)\" d=\"M7.798 0v7.099l8.086 8.062 3.632-3.804z\"/>\n                            <path d=\"M0 19v-2.976h.706v1.163h.387l.902-1.163h.832l-1.25 1.488L2.828 19h-.832l-.902-1.126H.706V19H0zm3.211 0v-2.976h.95l.487 1.2h.108l.481-1.2h.956V19h-.654v-1.775h-.12l-.452 1.034h-.423l-.578-1.034h-.094V19H3.21zm5.153-1.77c.13.02.412.077.568.11.451.096.755.317.755.807 0 .45-.375.853-1.138.853-.704 0-1.163-.354-1.21-.852h.384c.067.39.43.522.843.522.417 0 .737-.185.737-.514 0-.31-.215-.427-.51-.491-.151-.032-.446-.085-.594-.117-.438-.084-.729-.31-.729-.728 0-.446.38-.796 1.058-.796.624 0 1.024.314 1.091.776h-.383c-.072-.29-.278-.446-.717-.446-.362 0-.665.157-.665.458 0 .278.257.366.51.418zm4.007-1.154v.322h-.986v2.55h-.38v-2.55h-.994v-.322h2.36zm2.568 0h.403v1.846c0 .68-.439 1.078-1.258 1.078-.82 0-1.258-.398-1.258-1.078v-1.846h.403v1.842c0 .45.296.752.855.752.56 0 .855-.301.855-.752v-1.842zm1.116 0h1.255c1.03 0 1.552.571 1.552 1.436 0 .86-.522 1.436-1.552 1.436h-1.255v-2.872zm.37 2.542h.886c.867 0 1.198-.507 1.198-1.106 0-.6-.33-1.106-1.198-1.106h-.887v2.212zm2.983-2.542h.38v2.872h-.38v-2.872zm2.548-.052c.982 0 1.507.664 1.507 1.488S22.938 19 21.956 19c-.986 0-1.506-.664-1.506-1.488s.52-1.488 1.506-1.488zm.004 2.646c.845 0 1.203-.559 1.203-1.158 0-.6-.358-1.158-1.203-1.158-.845 0-1.203.559-1.203 1.158 0 .6.358 1.158 1.203 1.158zm2.276-2.646v.126h-.23v.56h-.153v-.56h-.23v-.126h.613zm.076.687v-.687h.22l.112.277h.024l.112-.277H25v.687h-.133v-.512h-.025l-.115.277h-.143l-.114-.277h-.025v.512h-.133z\"\n                                  fill-rule=\"nonzero\"/>\n                        </g>\n                    </svg>\n                </a>\n                <a class=\"IndexPartners-partner IndexPartners-partner--zw\" href=\"https://www.zeworkroom.com/\"\n                   target=\"_blank\">\n                    ";
output += runtime.suppressValue((lineno = 59, colno = 44, runtime.callWrap(runtime.memberLookup((t_1),"svgSprite"), "macros[\"svgSprite\"]", context, ["zw",runtime.makeKeywordArgs({"caller": (function (){var macro_t_10 = runtime.makeMacro(
[], 
[], 
function (kwargs) {
var callerFrame = frame;
frame = frame.push(true);
kwargs = kwargs || {};
if (Object.prototype.hasOwnProperty.call(kwargs, "caller")) {
frame.set("caller", kwargs.caller); }
var t_11 = "";;
frame = frame.pop();
return new runtime.SafeString(t_11);
});
return macro_t_10;})()})])), env.opts.autoescape);
output += "</a>\n            </div>\n        </div>\n    </div>\n</div>";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["assets/app/front/components/IndexPartners/IndexPartners.jinja"] , dependencies)


//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/IndexPartners/IndexPartners.jinja
// module id = 30
// module chunks = 0